<script setup>
import { computed } from "vue";
import useChargemapMessageStyles from "../../../composables/useChargemapMessageStyles";
import { BadgeType } from "../../../interfaces/UI";
const props = defineProps({
  type: {
    type: String,
    default: BadgeType.INFO
  },
  hasShadow: {
    type: Boolean,
    default: false
  }
});
defineEmits(["actionClick"]);
const { containerBackgroundClass, messageClass, iconClass, actionSlotClass } = useChargemapMessageStyles(props.type);
const actionSlotBorderClass = computed(() => {
  switch (props.type) {
    case BadgeType.NEUTRAL:
      return "border-button-secondary-neutral";
    case BadgeType.SUCCESS:
      return "border-button-secondary-positive";
    case BadgeType.WARNING:
      return "border-button-secondary-warning";
    case BadgeType.ERROR:
      return "border-button-secondary-negative";
    case BadgeType.INFO:
    default:
      return "border-button-secondary-branding";
  }
});
</script>

<template>
    <div
        class="flex rounded-lg w-full gap-2 items-start h-fit p-4"
        :class="[
  containerBackgroundClass,
  { 'shadow-lower-3': props.hasShadow }
]"
    >
        <div
            v-if="$slots.icon"
            class="size-5 md:size-6 flex mb-auto"
            :class="iconClass"
        >
            <slot name="icon" />
        </div>
        <div
            class="flex flex-col gap-2 md:gap-4 items-start justify-center w-full"
        >
            <div
                class="text-[13px] md:text-[17px] text-left font-normal w-full leading-4 md:leading-5"
                :class="messageClass"
            >
                <slot />
            </div>
            <span
                v-if="$slots.action"
                class="h-8 md:h-10 flex border rounded md:rounded-lg p-2 md:px-4 md:py-1.5 cursor-pointer font-semibold text-[11px] md:text-[15px] leading-[13px] md:leading-[18px]"
                :class="[actionSlotClass, actionSlotBorderClass]"
                @click="$emit('actionClick')"
            >
                <slot name="action" />
            </span>
        </div>
    </div>
</template>
